import isEqual from "lodash.isequal";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import get from "lodash.get";
import {
  getCardLayerOptions,
  getFormattedCardDiscount,
} from "../../../app/Helper/CardHelper";
import { getPopupURL } from "../../../app/Helper/CommonHelper";

import CardDuplicateDiscount from "./CardDuplicateDiscount";
import CardBillingDiscount from "./CardBillingDiscount";
import CardMonthlyFree from "./CardMonthlyFree";
import CardEvent from "./CardEvent";
import PayDiscount from "./PayDiscount";
import PopupLayer from "../common/PopupLayer";

/**
 * 결제혜택 컴포넌트
 * - 카드 중복할인
 * - 카드 청구할인
 * - 카드 할부
 * - 카드 이벤트
 */
function CardBenefit() {
  const [isOpenLayer, setIsOpenLayer] = useState(false);
  const [metaCardDiscount, setMetaCardDiscount] = useState();
  const [layerOptions, setLayerOptions] = useState(getCardLayerOptions());

  const {
    cardDiscount,
    cardMonthlyFree,
    payDiscount,
    metaCardDiscountDataFromJunsi,
  } = useSelector(
    (state) => ({
      cardDiscount: state.default.cardDiscount
        ? state.default.cardDiscount.response
        : null,
      cardMonthlyFree: state.default.cardMonthlyFree
        ? state.default.cardMonthlyFree.response
        : null,
      payDiscount: state.fetchApi.payDiscount
        ? state.fetchApi.payDiscount
        : null,
      metaCardDiscountDataFromJunsi: state.fetchApi.metaCardDiscount
        ? state.fetchApi.metaCardDiscount
        : null,
    }),
    isEqual
  );
  const {
    cardInfo,
    isMetaCardDiscount,
    isCashabilityDeal,
    discountInfosPrice,
    htDealInfo: { cardDuplicateDiscountInfos },
  } = TMON.htStaticData;
  const isCardBenefitRender = !(Number(discountInfosPrice) === 0);
  const isCardEventRender =
    cardDiscount && !TMON.oApp.oUtil.isEmpty(cardDiscount.data);
  const isCardMonthlyFreeRender =
    cardMonthlyFree && !TMON.oApp.oUtil.isEmpty(cardMonthlyFree.data);
  const isCardDuplicateDiscountRender = !TMON.oApp.oUtil.isEmpty(
    cardDuplicateDiscountInfos
  );
  const isCardBillingDiscountRender = isMetaCardDiscount && !isCashabilityDeal;

  /**
   * 결제혜택 어드민을 따로 만들 수 없어 전시 어드민을 통해 데이터를 가져온다. [SDLUI-2042]
   * 전시 어드민을 통하다 보니 필드명이 전시에 맞추어져 있어, 임의로 특정 필드를 정해 데이터를 받기로 했다.
   * configDataList에 templateConfigComponents 배열이 있고, 해당 배열에 실제 사용할 정보가 있다.
   * 해당 정보는 토스 추가할인 정보이며, linkInformation url 정보와 랜더링할 textBannerContent 정보를 사용한다.
   */
  const payDiscountDataFromJunsis = get(
    payDiscount,
    ["configInfo", 0, "configDataList", 0, "templateConfigComponents"],
    []
  );
  const isPayDiscountDataFromJunsiRender =
    payDiscountDataFromJunsis.length !== 0;

  const metaCardDiscountArr = get(
    metaCardDiscountDataFromJunsi,
    "configInfo[0].configDataList[0].templateConfigComponents",
    []
  );

  const metaCardDiscountPopupArr = get(
    metaCardDiscountDataFromJunsi,
    "configInfo[0].configDataList[1].templateConfigComponents",
    []
  );

  useEffect(() => {
    if (metaCardDiscountArr.length && metaCardDiscountPopupArr.length) {
      const formattedCardDiscount = getFormattedCardDiscount(
        metaCardDiscountArr
      );
      const formattedCardDiscountPopup = getFormattedCardDiscount(
        metaCardDiscountPopupArr
      );
      setMetaCardDiscount(formattedCardDiscount);
      setLayerOptions(getCardLayerOptions(formattedCardDiscountPopup));
    }
  }, [metaCardDiscountArr, metaCardDiscountPopupArr]);

  if (
    !isCardEventRender &&
    !isCardMonthlyFreeRender &&
    !isCardDuplicateDiscountRender &&
    !isCardBillingDiscountRender &&
    !isPayDiscountDataFromJunsiRender
  ) {
    return null;
  }

  const onCloseLayer = (e) => {
    e.preventDefault();
    setIsOpenLayer(false);
  };
  const onClickCardDiscount = (e) => {
    e.preventDefault();
    if (TMON.oApp.sPlatform === "MA") {
      // card popup data가 길게 들어가 서버에서 정보 내려 받음 (cardBillingDiscount만 옵션 설정)
      // data parameter 개선을 위해 localstorage 사용
      localStorage.setItem(
        "deal_popup_data",
        JSON.stringify({
          ...layerOptions,
          dealSrls: String(TMON.htStaticData.htDealInfo.dealNo),
        })
      );

      TMON.app.callApp(
        "webview",
        "showView",
        "결제혜택",
        getPopupURL("card"),
        true
      );
    } else {
      setIsOpenLayer(true);
    }
  };
  const onClickPayDiscount = (e, url) => {
    e.preventDefault();
    if (!url) {
      return;
    }

    if (TMON.oApp.sPlatform === "MA") {
      TMON.app.callApp("webview", "showView", "결제혜택", url, true);
    } else {
      window.open(url, "_blank");
    }
  };

  return (
    isCardBenefitRender && (
      <div className="deal_info_unit">
        <div className="info_unit_title">
          <h3 className="title">결제혜택</h3>
        </div>
        <div className="info_unit_contents">
          <div
            className="info_unit_button"
            role="button"
            data-tlarea="DDPB"
            data-tlord="1"
            onClick={onClickCardDiscount}
          >
            {isCardEventRender && <CardEvent cardDiscount={cardDiscount} />}
            {isCardMonthlyFreeRender && (
              <CardMonthlyFree cardMonthlyFree={cardMonthlyFree} />
            )}
            {isCardDuplicateDiscountRender && (
              <CardDuplicateDiscount
                cardInfo={cardInfo}
                cardDuplicateDiscountInfos={cardDuplicateDiscountInfos}
              />
            )}
            {isCardBillingDiscountRender && (
              <CardBillingDiscount
                cardDuplicateDiscountInfos={cardDuplicateDiscountInfos}
                metaCardDiscount={metaCardDiscount}
              />
            )}
          </div>
          {payDiscountDataFromJunsis.map((payDiscountData) => {
            const payDiscountKey = get(payDiscountData, ["bannerSeqNo"], null);
            const textBannerContent = get(
              payDiscountData,
              ["textBannerContent"],
              null
            );
            const url = get(payDiscountData, ["linkInformation"], null);
            return (
              <div
                className="info_unit_button"
                role="button"
                data-tlarea="DDPB"
                data-tlord="2"
                onClick={(e) => onClickPayDiscount(e, url)}
                key={payDiscountKey}
              >
                <PayDiscount textBannerContent={textBannerContent} />
              </div>
            );
          })}
          {isOpenLayer && (
            <PopupLayer
              title="결제혜택"
              onClose={onCloseLayer}
              popupKey="card"
              layerOptions={layerOptions}
            />
          )}
        </div>
      </div>
    )
  );
}

export default CardBenefit;
